import React, { useState } from "react";
import {Button, Modal, Form, Spinner} from "react-bootstrap";
import { useForm } from "react-hook-form";

import authService from "../services/auth.service";

const ForgotPasswordModal = () => {

   const [msg, setMsg] = useState("");
   const [isSending, setIsSending] = useState(false);
   const [show, setShow] = useState(false);
   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);

   const {
      handleSubmit,
      register,
      formState: { errors },
   } = useForm();

   const onSubmitReset = (data) => {
      setMsg("");
      setIsSending(true);
      authService
        .forgotPassword(data.username)
        .then((data) => {
          if (data.data.status === "OK") {
            setIsSending(false);
            setMsg("Email to reset password has been sent.");
          }
        })
        .catch((error) => {
          setIsSending(false);
          setMsg(error.response.data.message);
        });
    };

    return (
      <div>
        <>
          <span
            onClick={handleShow}
            className="mb-1 small text-decoration-underline"
            style={{cursor: "pointer"}}
          >
            Forgot password?
          </span>
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
               <Modal.Title>Forgot Password</Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit(onSubmitReset)}>
               
               <Modal.Body>
                  <p>Enter your username and we will send an email to the address linked with your username</p>
                  <Form.Group className="mb-3" controlId="username">
                     <Form.Control type="input" placeholder="Username" 
                           {...register("username", {
                           required: "Username is required",
                           
                           })}
                     />  
                     {errors.username && (
                        <Form.Text className="text-danger">
                        {errors.username.message}
                        </Form.Text>
                     )}                     
                  </Form.Group>
                  {msg && (
                              <Form.Text className="text-danger">
                              {msg}
                              </Form.Text>
                           )}  
              </Modal.Body>

              <Modal.Footer>
                <Button
                  onClick={handleSubmit(onSubmitReset)}
                  disabled={isSending}
                  className="w-full sm:w-auto"
                >
                  {isSending ? <Spinner animation="border" role="status" /> : "Send email"}
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        </>
      </div>
    );



};

export default ForgotPasswordModal;